export default "__VITE_ASSET__Dskpirws__"